import React from 'react';

type Props = {
  children: React.ReactNode;
};
function TenantCenterCardLayout({ children }: Props) {
  return (
    <main className='flex min-h-screen bg-[#F9F9F9] md:block md:bg-white'>
      <div className='grid w-full place-items-center py-10 md:p-0'>
        <div className='w-full max-w-[480px] rounded bg-white p-10 md:max-w-full md:px-10 md:py-20 sm:px-5'>
          {children}
        </div>
      </div>
    </main>
  );
}

export default TenantCenterCardLayout;
